import React from 'react';
import { Checkbox, TextButton, TextButtonPriority as TEXT_BUTTON_PRIORITY, } from 'wix-ui-tpa';
import withErrorMessage from '../../withErrorMessage';
import { st, classes } from './Checkbox.st.css';
const withLink = (renderInfo) => {
    var _a, _b, _c;
    if ((_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _a === void 0 ? void 0 : _a.checkboxSettings) {
        const { linkLabel: text, link, } = (_b = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _b === void 0 ? void 0 : _b.checkboxSettings;
        if (link && ((_c = link.external) === null || _c === void 0 ? void 0 : _c.url)) {
            return (React.createElement(TextButton, { priority: TEXT_BUTTON_PRIORITY.link, as: "a", className: classes.link, href: link.external.url, 
                // @ts-expect-error
                target: "_blank" }, text));
        }
    }
    return undefined;
};
const CheckboxComponent = ({ field: { renderInfo }, invalidMessage, errorMessageId, onChange, className, required, disabled, value = false, inputRef, }) => {
    var _a;
    const label = (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _a === void 0 ? void 0 : _a.label;
    const link = withLink(renderInfo);
    const formattedLabel = label || link ? (React.createElement("span", { className: classes.label },
        label ? label : null,
        " ",
        link ? link : null)) : undefined;
    return (React.createElement(Checkbox, { "data-hook": "checkbox-field", label: formattedLabel, checked: value, disabled: disabled, ref: (ref) => {
            if (inputRef) {
                inputRef(ref);
            }
        }, className: st(classes.root, { required: required || false }, className), error: !!invalidMessage, "aria-describedby": invalidMessage ? errorMessageId : undefined, onChange: () => {
            onChange(!value);
        } }));
};
export default withErrorMessage(CheckboxComponent);
//# sourceMappingURL=Checkbox.js.map